import { useState } from "react";
import { useStateLocalStorage } from "@dotlegal/dotlegal-ui-components";
import { DataSubjectSaveModel, DataSubjectViewModel } from "../DataSubject.types";

import { useDotLegalQuery, useDotLegalQueryClient } from "@common/hooks/dotLegalReactQuery";

export function useDataSubjectsDataMapping() {
    const queryClient = useDotLegalQueryClient();
    const [showAllDataSubjects, setshowAllDataSubjects] = useStateLocalStorage("onlyActiveDataSubjects", false);
    const [showAddEditDialog, setShowAddEditDialog] = useState(false);
    const [showDeleteDataSubjectDialog, setShowDeleteDataSubjectDialog] = useState(false);
    const [selectedDataSubject, setSelectedDataSubject] = useState<DataSubjectSaveModel | undefined>(undefined);
    const [showChangeStatusDialog, setShowChangeStausDialog] = useState(false);

    const queryPart = `?showAllDataSubjects=${showAllDataSubjects}`;
    const url = `/dataSubjects${queryPart}`;
    let { isLoading, data } = useDotLegalQuery<Array<DataSubjectViewModel>>(url);

    const OnSave = () => {
        queryClient.refetchQueries(url);
    };

    return {
        isLoading,
        data,
        OnSave,
        showChangeStatusDialog,
        setShowChangeStausDialog,
        showAllDataSubjects,
        setshowAllDataSubjects,
        showAddEditDialog,
        setShowAddEditDialog,
        showDeleteDataSubjectDialog,
        setShowDeleteDataSubjectDialog,
        selectedDataSubject,
        setSelectedDataSubject,
    };
}
